export default __webpack_public_path__ + "997fc0308688accf427b4c42edc73000.png";